import o from"styled-components";import{theme as i}from"../../../theme.js";const e=o.div`
  background-color: ${i.colors.primary[500]};
`,r=o.div`
  width: ${i.maxWidth};
  margin: 0 auto;
  box-sizing: border-box;
  @media screen and (max-width: ${i.breakpoints.xl}) {
    width: 100%;
  }
`,t=o.h1`
  font-size: 48px;
  line-height: 62px;
  font-weight: 900;
  color: ${i.colors.shades[0]};
  margin: 0;
  @media screen and (max-width: ${i.breakpoints.md}) {
    font-size: 36px;
    line-height: 48px;
  }
  `,n=o.p`
  font-size: 16px;
  line-height: 24px;
  color: ${i.colors.shades[0]};
  margin: 0;
`;export{e as Container,n as Description,t as Title,r as Wrapper};
